import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/organisms/Header';
import Button from '../components/atoms/Button';
import Icon from '../components/atoms/Icon';

const ResumeBuilderPage = () => {
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [candidateData, setCandidateData] = useState(null);
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);
  const [showAIEnhancer, setShowAIEnhancer] = useState(false);
  const [aiPrompt, setAiPrompt] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [enhancing, setEnhancing] = useState(false);

  const templates = [
    {
      id: 1,
      name: 'Modern Resume',
      category: 'Modern',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDXuPrn6SaXAiTefRaZTJGWEods692SWjccevUGAqimt3QNo1HHKnbPxMHGE-Wmq5l1BUKLPzqt_0xASa5F5o0Bv_K1eEs1cQEj-zBjv2MxtmDwIwwHn4c1sTFuFylA-zkvP3IY2dLrRnQu992fPIwcMpaIlXsozRiqf_0VOQMOqokZgxqpySSliuMRcFZKqMoyfr8L8yU2BjpRy1itrToeWloB3A97_Q2dV084Asm-Na-Lq6rABYy5ZGvt6q_4VEySXuOp6aC683k1',
      colors: { primary: '#2563eb', secondary: '#1e40af', accent: '#3b82f6' }
    },
    {
      id: 2,
      name: 'Creative Resume',
      category: 'Creative',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCMAwfPh0YvAw_lq71SBm4-PPTVoNzpgIB_MZ7Kgqh9DfbKqgxvoLW6qPwl9pQKfC-anZCgKh-0wrM-XuPEOhdaIhYpulwqewYprRpnUVXJugMgafkDCDkNlMzZXyDf9GmdPi7l96L-Qg1EA6FtwYixPBPdrEvJj59lcrYvnlqKqhbd-6hxnwM-jlYjDXYnWWJBFq_Ic7PVBCwoIYh67lHWLpiWTk7GF6s_Bvz73Rcxv25C-7UJ7oiIDT2swCWHgB8IK7bASNowKTDu',
      colors: { primary: '#7c3aed', secondary: '#6d28d9', accent: '#8b5cf6' }
    },
    {
      id: 3,
      name: 'Corporate Resume',
      category: 'Professional',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD8xgXuvZtvM9rNWqpCM5SAG92VIk4VYhGbeCpiAHOsvjVki0VF4njy4PSbNg1nTD-lDtnxQzrRrJAIIl2p61VfCHTl3Vg_Lbce8vndbM7Ze9Tr0Cvb8JXaWlO4aSElqt4amywHzN7GQ2JfhXFG4cBY342ZP5dzQMi79zF9YAlSBkQvNyPolwdjraU1WYu5ASmFJX0SMf37ELSrzNlyKI3sdJcMLB28RyGQb23msNDutLW8fs3sWjmd1v87l4d8zEtWVfxDZ_gfe4Ob',
      colors: { primary: '#059669', secondary: '#047857', accent: '#10b981' }
    },
    {
      id: 4,
      name: 'Chronological Classic',
      category: 'Professional',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBw_fPNv1DiZoZLd33E4r7arPgzoAuBQlI-NALAYRif2iJzX29yHczgkSQGtRl2sbVIYooB1P4Tn6ItQZq5BQB96wpUCnhPIbLHJvJjTsZXLp8VlTZmwpqjcL2pmPQDlZ06Oazxo6gjXvERkFrB2MnwrguKnXSW1PdIXC7TkU_SKNy1oexlYnko70BGTU0jyU3lN7orNG8a2ZU4ckiZ4veNOg8VoW-iKUM8XmPvqWRk2R4s_G4CWLgvu4gq93aoa2C1gv7peGoQBeWf',
      colors: { primary: '#dc2626', secondary: '#b91c1c', accent: '#ef4444' }
    },
    {
      id: 5,
      name: 'Minimalist Resume',
      category: 'Minimalist',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDpNVhjn0vvOlloCe9sR6CF7RjN1dYH-qiVwRWPRyw_ye-j2y8bo4pcEKdi0wnzmFyoUfA0GObBYtKtl5Y4ll0W2e-nOvP_J7YcOOGjMO15huYhrg1gqNt8dBJXax1DK7Y-B7NV3r1UiiQiXHDAnl-8HcqCPrzfkdeKFhFLpg-GMibq1VLlSIVhA3wMblrU0oDo8O34UfTUkLE4NrSUQn9go2jxOd8DWi_jybjuUThxSOJomS1_OHyT6C8Eln9yfODKIYdMKjyq5A9J',
      colors: { primary: '#000000', secondary: '#374151', accent: '#6b7280' }
    },
  ];

  useEffect(() => {
    // Load selected template from localStorage
    const savedTemplate = localStorage.getItem('dutlaunch_resume_template');
    if (savedTemplate) {
      setSelectedTemplate(JSON.parse(savedTemplate));
    } else {
      setSelectedTemplate(templates[0]); // Default to first template
    }

    // Load candidate data from localStorage (already fetched in profile page)
    const storedProfile = localStorage.getItem('dutlaunch_candidate_profile');
    if (storedProfile) {
      const profileData = JSON.parse(storedProfile);
      setCandidateData(profileData);
    } else {
      // Fallback: fetch from API
      const candidateId = localStorage.getItem('dutlaunch_user_id');
      const candidateEmail = localStorage.getItem('dutlaunch_email');
      
      if (candidateId && candidateEmail) {
        fetchCandidateProfile(candidateId, candidateEmail);
      }
    }
  }, []);

  const fetchCandidateProfile = async (candidateId, email) => {
    try {
      const response = await fetch(
        `https://aptirix-version-610696728606.asia-south1.run.app/api/candidates/profile?candidate_id=${candidateId}&email=${email}`
      );
      if (response.ok) {
        const data = await response.json();
        setCandidateData(data);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const handleTemplateChange = (template) => {
    setSelectedTemplate(template);
    localStorage.setItem('dutlaunch_resume_template', JSON.stringify(template));
    setShowTemplateSelector(false);
  };

  const handleDownloadResume = () => {
    alert('Downloading resume as PDF...');
    // TODO: Implement PDF generation
  };

  const handleAIEnhance = async () => {
    if (!aiPrompt && !jobDescription) {
      alert('Please provide either a custom prompt or job description');
      return;
    }

    setEnhancing(true);
    try {
      // TODO: Call AI enhancement API
      await new Promise(resolve => setTimeout(resolve, 2000)); // Simulate API call
      alert('✓ Resume enhanced successfully!');
      setShowAIEnhancer(false);
      setAiPrompt('');
      setJobDescription('');
    } catch (error) {
      console.error('Error enhancing resume:', error);
      alert('Failed to enhance resume');
    } finally {
      setEnhancing(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header Actions */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Resume Builder</h1>
            <p className="text-gray-600 mt-1">
              Template: <span className="font-semibold text-primary">{selectedTemplate?.name}</span>
            </p>
          </div>
          
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => setShowTemplateSelector(true)}
              className="flex items-center gap-2"
            >
              <Icon name="palette" />
              Change Template
            </Button>
            
            <Button
              variant="outline"
              onClick={() => setShowAIEnhancer(true)}
              className="flex items-center gap-2"
            >
              <Icon name="auto_awesome" />
              AI Enhance
            </Button>
            
            <Button
              onClick={handleDownloadResume}
              className="flex items-center gap-2"
            >
              <Icon name="download" />
              Download PDF
            </Button>
          </div>
        </div>

        {/* Resume Preview */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Preview Area */}
          <div className="lg:col-span-2">
            <div 
              className="bg-white rounded-xl shadow-lg p-8 min-h-[1000px] transition-all duration-300"
              style={{
                borderLeft: `4px solid ${selectedTemplate?.colors?.primary || '#2563eb'}`
              }}
            >
              <div className="text-center mb-8">
                <h2 
                  className="text-4xl font-bold mb-2"
                  style={{ color: selectedTemplate?.colors?.primary || '#111827' }}
                >
                  {candidateData?.full_name || 'Your Name'}
                </h2>
                <p className="text-xl text-gray-600 mb-4">
                  {candidateData?.job_role || 'Your Job Title'}
                </p>
                <div className="flex justify-center gap-4 text-sm text-gray-600">
                  <span className="flex items-center gap-1">
                    <Icon name="email" size={16} />
                    {candidateData?.email || 'email@example.com'}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="phone" size={16} />
                    {candidateData?.phone || '+1234567890'}
                  </span>
                </div>
              </div>

              {/* Skills Section */}
              {candidateData?.skills && candidateData.skills.length > 0 && (
                <div className="mb-8">
                  <h3 
                    className="text-2xl font-bold mb-4 pb-2"
                    style={{ 
                      color: selectedTemplate?.colors?.primary || '#111827',
                      borderBottom: `2px solid ${selectedTemplate?.colors?.primary || '#2563eb'}`
                    }}
                  >
                    Skills
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {candidateData.skills.map((skill, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 rounded-full text-sm font-medium"
                        style={{
                          backgroundColor: `${selectedTemplate?.colors?.primary || '#2563eb'}15`,
                          color: selectedTemplate?.colors?.primary || '#2563eb'
                        }}
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Experience Section */}
              <div className="mb-8">
                <h3 
                  className="text-2xl font-bold mb-4 pb-2"
                  style={{ 
                    color: selectedTemplate?.colors?.primary || '#111827',
                    borderBottom: `2px solid ${selectedTemplate?.colors?.primary || '#2563eb'}`
                  }}
                >
                  Experience
                </h3>
                {candidateData?.resume_url ? (
                  <div className="space-y-4">
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                      <p className="text-sm text-blue-800">
                        <Icon name="info" size={16} className="inline mr-1" />
                        Your resume has been uploaded. The content will be extracted and displayed here.
                      </p>
                      <p className="text-xs text-blue-600 mt-2">
                        Resume file: {candidateData.resume_filename || 'resume.pdf'}
                      </p>
                    </div>
                    
                    {/* Placeholder for extracted experience */}
                    <div className="space-y-6">
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900">Senior Software Engineer</h4>
                        <p className="text-gray-600">Tech Company • 2020 - Present</p>
                        <ul className="mt-2 space-y-1 text-gray-700 list-disc list-inside">
                          <li>Led development of microservices architecture</li>
                          <li>Managed team of 5 developers</li>
                          <li>Improved system performance by 40%</li>
                        </ul>
                      </div>
                      
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900">Software Developer</h4>
                        <p className="text-gray-600">Startup Inc • 2018 - 2020</p>
                        <ul className="mt-2 space-y-1 text-gray-700 list-disc list-inside">
                          <li>Developed full-stack web applications</li>
                          <li>Collaborated with cross-functional teams</li>
                          <li>Implemented CI/CD pipelines</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                    <Icon name="work_outline" size={48} className="text-gray-400 mx-auto mb-3" />
                    <p className="text-gray-600 mb-2">No resume uploaded yet</p>
                    <button
                      onClick={() => navigate('/profile/view')}
                      className="text-primary hover:underline font-medium"
                    >
                      Upload your resume to auto-fill this section
                    </button>
                  </div>
                )}
              </div>

              {/* Education Section */}
              <div className="mb-8">
                <h3 
                  className="text-2xl font-bold mb-4 pb-2"
                  style={{ 
                    color: selectedTemplate?.colors?.primary || '#111827',
                    borderBottom: `2px solid ${selectedTemplate?.colors?.primary || '#2563eb'}`
                  }}
                >
                  Education
                </h3>
                {candidateData?.resume_url ? (
                  <div className="space-y-4">
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Bachelor of Technology in Computer Science</h4>
                      <p className="text-gray-600">University Name • 2014 - 2018</p>
                      <p className="text-gray-700 mt-1">GPA: 3.8/4.0</p>
                    </div>
                    
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Certifications</h4>
                      <ul className="mt-2 space-y-1 text-gray-700 list-disc list-inside">
                        <li>AWS Certified Solutions Architect</li>
                        <li>Google Cloud Professional</li>
                        <li>Kubernetes Administrator (CKA)</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                    <Icon name="school" size={48} className="text-gray-400 mx-auto mb-3" />
                    <p className="text-gray-600 mb-2">No resume uploaded yet</p>
                    <button
                      onClick={() => navigate('/profile/view')}
                      className="text-primary hover:underline font-medium"
                    >
                      Upload your resume to auto-fill this section
                    </button>
                  </div>
                )}
              </div>

              {/* Projects Section (if available) */}
              {candidateData?.resume_url && (
                <div className="mb-8">
                  <h3 
                    className="text-2xl font-bold mb-4 pb-2"
                    style={{ 
                      color: selectedTemplate?.colors?.primary || '#111827',
                      borderBottom: `2px solid ${selectedTemplate?.colors?.primary || '#2563eb'}`
                    }}
                  >
                    Projects
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">E-commerce Platform</h4>
                      <p className="text-gray-700 mt-1">
                        Built a scalable e-commerce platform using React, Node.js, and MongoDB. 
                        Implemented payment gateway integration and real-time inventory management.
                      </p>
                    </div>
                    
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">AI Chatbot</h4>
                      <p className="text-gray-700 mt-1">
                        Developed an AI-powered customer service chatbot using Python and TensorFlow. 
                        Achieved 85% accuracy in intent classification.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Quick Actions</h3>
              <div className="space-y-3">
                <button
                  onClick={() => navigate('/profile/view')}
                  className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition flex items-center gap-3"
                >
                  <Icon name="edit" className="text-primary" />
                  <span className="font-medium">Edit Profile</span>
                </button>
                
                <button
                  onClick={() => setShowTemplateSelector(true)}
                  className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition flex items-center gap-3"
                >
                  <Icon name="palette" className="text-primary" />
                  <span className="font-medium">Change Template</span>
                </button>
                
                <button
                  onClick={() => setShowAIEnhancer(true)}
                  className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition flex items-center gap-3"
                >
                  <Icon name="auto_awesome" className="text-primary" />
                  <span className="font-medium">AI Enhance</span>
                </button>
              </div>
            </div>

            <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-2">💡 Pro Tip</h3>
              <p className="text-sm text-gray-700">
                Use AI enhancement to tailor your resume for specific job descriptions and increase your chances of getting hired!
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Template Selector Modal */}
      {showTemplateSelector && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900">Choose Template</h2>
              <button
                onClick={() => setShowTemplateSelector(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <Icon name="close" size={24} />
              </button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {templates.map((template) => (
                <button
                  key={template.id}
                  onClick={() => handleTemplateChange(template)}
                  className={`p-3 border-2 rounded-lg hover:border-primary transition ${
                    selectedTemplate?.id === template.id
                      ? 'border-primary bg-primary/5 shadow-lg'
                      : 'border-gray-200'
                  }`}
                >
                  <div className="aspect-[3/4] bg-gray-100 rounded mb-3 overflow-hidden">
                    <img
                      src={template.image}
                      alt={template.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="font-semibold text-gray-900">{template.name}</h3>
                  <p className="text-sm text-gray-600">{template.category}</p>
                  {selectedTemplate?.id === template.id && (
                    <div className="mt-2 flex items-center justify-center gap-1 text-primary text-sm font-medium">
                      <Icon name="check_circle" size={16} />
                      Selected
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* AI Enhancer Modal */}
      {showAIEnhancer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-2xl w-full">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900">AI Resume Enhancer</h2>
              <button
                onClick={() => setShowAIEnhancer(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <Icon name="close" size={24} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Paste Job Description (Optional)
                </label>
                <textarea
                  value={jobDescription}
                  onChange={(e) => setJobDescription(e.target.value)}
                  placeholder="Paste the job description here to tailor your resume..."
                  className="w-full h-32 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                />
              </div>

              <div className="text-center text-gray-500 font-medium">OR</div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Custom Enhancement Request
                </label>
                <textarea
                  value={aiPrompt}
                  onChange={(e) => setAiPrompt(e.target.value)}
                  placeholder="E.g., 'Make it more professional', 'Add more technical keywords', 'Emphasize leadership skills'..."
                  className="w-full h-24 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                />
              </div>

              <div className="flex gap-3 justify-end">
                <Button
                  variant="outline"
                  onClick={() => setShowAIEnhancer(false)}
                  disabled={enhancing}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleAIEnhance}
                  disabled={enhancing}
                  className="flex items-center gap-2"
                >
                  {enhancing ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      Enhancing...
                    </>
                  ) : (
                    <>
                      <Icon name="auto_awesome" />
                      Enhance Resume
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResumeBuilderPage;
